/**
 * Linha somente leitura com a classificação do item (demanda · NC ·
 * processo · causa · imputação · responsável). Sem nada classificado,
 * mostra um chip discreto "Sem classificação" — o painel conta esses itens
 * como "não informado".
 */
import React from "react";

import { PecaLinha, Pill } from "./styles";

export default function ClassificacaoResumo({ item, mostrarVazio = true }) {
  if (!item) return null;
  const partes = [
    item.demanda_nome && `Demanda: ${item.demanda_nome}`,
    item.nao_conformidade_nome && `NC: ${item.nao_conformidade_nome}`,
    item.processo_origem_nome && `Origem: ${item.processo_origem_nome}`,
    item.causa_raiz_nome && `Causa: ${item.causa_raiz_nome}`,
    item.imputacao_display && `Imputação: ${item.imputacao_display}`,
    item.responsavel_nc_display && `Responsável: ${item.responsavel_nc_display}`,
  ].filter(Boolean);

  if (partes.length === 0) {
    return mostrarVazio ? (
      <PecaLinha>
        <Pill $tone="neutral" title="Nenhum eixo da não-qualidade foi informado">
          Sem classificação
        </Pill>
      </PecaLinha>
    ) : null;
  }
  return (
    <PecaLinha title={item.classificado_por_nome ? `Classificado por ${item.classificado_por_nome}` : ""}>
      {partes.join(" · ")}
      {item.classificacao_completa === false && (
        <>
          {" "}
          <Pill $tone="warning" title="Falta não conformidade ou processo de origem">incompleta</Pill>
        </>
      )}
    </PecaLinha>
  );
}
